import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import {
  displayProfileModal,
  setProfileModalPage,
} from '../../../modules/profile/actions/creators'

import ReferPage from '../components/ReferPage/ReferPage'

const mapStateToProps = reduxState => {
  const { auth, profile, errors } = reduxState

  const { accessToken } = auth

  const { referError } = errors

  const { primaryInfo, showProfileModal, profileModalPage } = profile

  return {
    accessToken,
    primaryInfo,
    showProfileModal,
    profileModalPage,
    referError,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      displayProfileModal,
      setProfileModalPage,
    },
    dispatch,
  )

const ConnectedReferPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ReferPage)

export default ConnectedReferPage
